<div class="row">
  <div class="col-lg-2 col-md-2 col-sm-3 col-3 text-center pr-0">
    <img *ngIf="loggedInUser.image" class="rounded-circle full-img" src="{{loggedInUser.image}}" alt="user" />
    <img *ngIf="!loggedInUser.image" class="rounded-circle full-img" src="assets/images/user_male.png" alt="user" />
  </div>
  <div class="col-lg-10 col-md-10 col-sm-9 col-9">
    <div class="font-nissan-brand-w01-bold">
      <!-- <h3>Jhon Diggle &nbsp;<button class="btn btn-danger btn-sm rounded-pill txt-small">Inactive{{accountStatus}}</button></h3> -->
      <h4>{{loggedInUser.name}}
        <!-- <button [ngClass]="{'Active': 'btn-success', 'Inactive': 'btn-danger', 'Pending': 'btn-warning'}[accountStatus]"
          class="btn btn-sm rounded-pill txt-small">{{accountStatus}}</button> -->
        <sup [ngClass]="{'Active':'badge-success', 'Inactive':'badge-danger', 'Pending':'badge-warning'}[accountStatus]"
          class="badge badge-pill txt-small algin-middle">{{accountStatus}}</sup>
      </h4>
      <!-- <h3>Jhon Diggle &nbsp;<button class="btn btn-warning btn-sm rounded-pill txt-small">Pending{{accountStatus}}</button></h3> -->
    </div>
    <div class="form-group">
      <label for="vin">Contact Information</label>
      <div>Email: <span class="text-muted">{{loggedInUser.email}}</span></div>
      <div>Phone: <span class="text-muted">{{loggedInUser.isd}}{{loggedInUser.phoneNumber}}&nbsp;</span>
        <span *ngIf="loggedInUser.multiFactorAuthentication=='ENABLED'">
          <i [ngClass]="{'true':'fa fa-check-circle text-success', 'false':'fa fa-exclamation-circle text-danger'}[loggedInUser.phoneNumberVerified]"
            data-toggle="tooltip" data-placement="right"
            title="{{loggedInUser.phoneNumberVerified?'Verified':'Unverfied'}}"></i>&nbsp;
          <i *ngIf="!loggedInUser.phoneNumberVerified" (click)="verifyProfile()"
            class="fas fa-check-square cursor-pointer maroon" data-toggle="tooltip" data-placement="right"
            title="Verify phone number"></i>
        </span>
      </div>
      <div *ngIf="loggedInUser.multiFactorAuthentication=='ENABLED'">MFA Preference: <span class="text-muted">{{loggedInUser.mfaPreference}}</span></div>
      <!-- <div>Preferred Language: <span class="text-muted" *ngFor="let localeLanguage of localeLanguages; let i = index">{{localeLanguage.language}}<span *ngIf="i < localeLanguages.length-1">, </span> </span></div> -->
   
    </div>

    <div *ngIf="isShowChangePasswordForm">
      <form #changePasswordForm="ngForm" novalidate (ngSubmit)="changePasswordFormSubmit(changePasswordForm)">
        <div class="form-group">
          <label><span class="maroon astrisk">&#10033;&nbsp;</span>Current Password</label>
          <input type="password" class="form-control" [(ngModel)]="changePasswordModal.oldPassword" name="oldPassword"
            #oldPassword="ngModel" required>
          <small class="text-danger text-center" *ngIf="oldPassword.errors && changePasswordForm.submitted">
            <p class="mb-0" *ngIf="oldPassword.errors.required">*Required</p>
          </small>
        </div>

        <div class="form-group">
          <label><span class="maroon astrisk">&#10033;&nbsp;</span>New Password</label>
          <!-- <input type="password" class="form-control" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" -->
          <input type="password" class="form-control" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[!@#$%^&*0-9a-zA-Z]{8,}"
            [(ngModel)]="changePasswordModal.password" name="password" #password="ngModel" required>
          <small class="text-danger text-center" *ngIf="password.errors && changePasswordForm.submitted">
            <p class="mb-0" *ngIf="password.errors.required">*Required</p>
            <p class="mb-0" *ngIf="!password.errors.required">{{passwordFormatError}}</p>
          </small>
        </div>

        <div class="form-group">
          <label><span class="maroon astrisk">&#10033;&nbsp;</span>Confirm Password</label>
          <input type="password" class="form-control" [(ngModel)]="changePasswordModal.confirmPassword"
            name="confirmPassword" #confirmPassword="ngModel" required>
          <small class="text-danger text-center" *ngIf="confirmPassword.errors && changePasswordForm.submitted">
            <p class="mb-0" *ngIf="confirmPassword.errors.required">*Required</p>
          </small>
        </div>

        <div>
          <button type="submit" class="btn btn-primary border pull-right btn-80">Update
          </button>
          <button (click)="initChangePasswordModal(); isShowChangePasswordForm = !isShowChangePasswordForm"
            class="btn btn-light border pull-right mr-2 btn-80">Cancel</button>
        </div>
      </form>
    </div>

    <div *ngIf="accountStatus == 'Active' && !isShowChangePasswordForm && !isShowUpdateUserForm" class="form-group pt-2">
      <!-- <button class="btn btn-light" (click)="onAccountDeactivate()">DEACTIVATE</button> -->
      <button class="btn btn-primary btn-165" (click)="isShowChangePasswordForm = !isShowChangePasswordForm;">CHANGE PASSWORD
        <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
      </button>
      <button class="btn btn-primary ml-md-2 mt-sm-0 mt-2 btn-165" (click)="(isShowUpdateUserForm = !isShowUpdateUserForm); onUpdateProfile()">UPDATE PROFILE
        <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
      </button>
    </div>
    <!-- <div *ngIf="accountStatus == 'Inactive'" class="form-group">
      <button class="btn btn-primary" (click)="onActivate()">ACTIVATE</button>
    </div>
    <div *ngIf="accountStatus == 'Pending'" class="form-group">
      <button class="btn btn-primary" (click)="onInviteResend()">RESEND REQUEST</button>
    </div> -->

    <div *ngIf="isShowUpdateUserForm">
      <form #updateUserForm="ngForm" novalidate (ngSubmit)="updateUserFormSubmit(updateUserForm)">
        <div class="form-group">
          <label><span class="maroon astrisk">&#10033;&nbsp;</span>Name</label>
          <input type="text" class="form-control" [(ngModel)]="updateUserModal.name" name="name" #name="ngModel"
            required>
          <small class="text-danger text-center" *ngIf="name.errors && updateUserForm.submitted">
            <p class="mb-0" *ngIf="name.errors.required">*Required</p>
          </small>
        </div>
        
        <!-- <div class="form-group">
          <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Country</label>
          <ng-template #rt_country let-r="result" let-t="term">
            <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
          </ng-template>
          <input id="typeahead-country-template" type="text" class="form-control" name="country" #country="ngModel" placeholder="Country Name..."
          [(ngModel)]="selectedCountryDetails" [ngbTypeahead]="searchCountry" [resultTemplate]="rt_country" [inputFormatter]="countryFormatter"
          [editable]='false' (selectItem)="onCountrySelected($event)" required>
          <small class="text-danger text-center" *ngIf="country.errors && updateUserForm.submitted">
            <p class="mb-0" *ngIf="country.errors.required">*Required</p>
          </small>
        </div> -->

        <!-- <div class="form-group">
          <label for="adminPhone"><span class="maroon  astrisk">&#10033;&nbsp;</span><span>Phone</span></label>
          <div class="">
            <ngx-intl-tel-input
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [separateDialCode]="true"
              [selectFirstCountry]="false"
              [searchCountryPlaceholder]="'Search Country'"
              [preferredCountries]="preferredCountries"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]" 
              [numberFormat]="PhoneNumberFormat.National"
              [selectedCountryISO]="selectedCountryISO"
              (countryChange)="onCountryChange($event)"
              [(ngModel)]="selectedPhone" 
              name="countryCode"
              #countryCode="ngModel"
              required
            >
            </ngx-intl-tel-input>
            <small class="text-danger text-center" *ngIf="countryCode.errors && updateUserForm.submitted">
              <p class="mb-0" *ngIf="countryCode.errors.required">*Required</p>
              <p class="mb-0" *ngIf="!countryCode.errors.required">Invalid Phone</p>
            </small>
          </div>
        </div> -->

        <!-- <div>
          <label for="countryIsd"><span class="maroon astrisk">&#10033;&nbsp;</span>Phone</label>
          <div class="form-group d-flex">
          <select id="countryIsd" [(ngModel)]="selectedCountryIsd" name="countryIsd" #countryIsd="ngModel"
            class="form-control" style="max-width: 173px; box-shadow: none">
            <option [value]="null">Select ISD</option>
            <option *ngFor="let country of countries" [value]="country.dialCode">{{country.label}}</option>
          </select>

          <input type="text" class="form-control" id="userPhone" name="userPhone" placeholder="Enter Phone"
            maxlength="12" [(ngModel)]="selectedUserPhone" #userPhone="ngModel" oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
          </div>

          <small class="text-danger text-center" *ngIf="userPhone.errors && updateUserForm.submitted">
          <p class="mb-0" *ngIf="userPhone.errors.required">*Required</p>
          </small>
        </div> -->

        <div>
          <label for="countryIsd"><span class="maroon astrisk">&#10033;&nbsp;</span>Phone</label>
          <div class="form-group d-flex custom-select-wrapper">
            <select [(ngModel)]="adminCountryIsotwo" name="country" (ngModelChange)="countryUpdated($event)">
              <option *ngFor="let c of allCountryList" [value]="c.isotwo">{{c.isd}} {{c.name}}</option>
            </select>
            <span class="selected-isd" *ngIf="adminCountryIsotwo">{{getadminCountryIsotwoIsd()}}</span>

            <input placeholder="Enter phone number" type="text" class="form-control" id="phoneElement" name="phoneElement"
              #phoneElement="ngModel" appPhoneValidator appPhoneFormatter [(ngModel)]="adminPhone" required />
          </div>

          <small class="text-danger text-center" *ngIf="phoneElement?.errors && updateUserForm.submitted">
            <p class="mb-0" *ngIf="phoneElement.errors?.required">*Required</p>
            <p class="mb-0" *ngIf="phoneElement.errors?.invalidPhone">Invalid Phone</p>
          </small>
        </div>

        <!-- <div class="form-group">
          <label><span class="maroon astrisk">&#10033;&nbsp;</span>Phone</label>
          <div class="row">
            <div class="col-4 pr-1">
              <ng-template #rt_isd let-r="result" let-t="term">
                <ngb-highlight [result]="r.name + ' ' + r.isd" [term]="t"></ngb-highlight>
              </ng-template>
              <input id="typeahead-isd-template" type="text" class="form-control" name="isd" #isd="ngModel" placeholder="ISD..."
              [(ngModel)]="selectedIsdDetails" [ngbTypeahead]="searchIsd" [resultTemplate]="rt_isd" [inputFormatter]="isdFormatter"
              [editable]='false' (selectItem)="onIsdSelected($event)" required disabled>
              <small class="text-danger text-center" *ngIf="isd.errors && updateUserForm.submitted">
                <p class="mb-0" *ngIf="isd.errors.required">*Required</p>
              </small>
            </div>
            <div class="col-8 pl-1">
              <input type="text" class="form-control" [pattern]="'[0-9]{' + phoneLength + '}'"
                [placeholder]="'X'.repeat(phoneLength)" [maxlength]="phoneLength" [(ngModel)]="updateUserModal.phone" name="phone"
                #phone="ngModel" oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
              <small class="text-danger text-center" *ngIf="phone.errors && updateUserForm.submitted">
                <p class="mb-0" *ngIf="phone.errors.required">*Required</p>
                <p class="mb-0" *ngIf="!phone.errors.required">Invalid Phone</p>
              </small>
            </div>
          </div>
        </div> -->

        <!-- <div class="form-group">
          <label><span class="maroon astrisk">&#10033;&nbsp;</span>Preferred Language</label>
          <div class="row">
            <div class="col">
              <div *ngFor="let language of allSupportedLanguages; let i = index"
                class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" name="checkbox" class="custom-control-input" [disabled]="false"
                  id="language_{{i}}" [checked]="language.ischecked"
                  (change)="onLanguageSelected($event.target.checked, i)">
                <label class="custom-control-label" for="language_{{i}}">{{language.language}}</label>
              </div>
            </div>
          </div>
        </div> -->

        <div class="form-group" *ngIf="loggedInUser.multiFactorAuthentication=='ENABLED'">
          <label><span class="maroon astrisk">&#10033;&nbsp;</span>MFA Preference</label>
          <div class="row">
            <div class="col">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="emailRadio" name="email" value="EMAIL" [(ngModel)]="updateUserModal.mfaPreference"
                  class="custom-control-input">
                <label class="custom-control-label" for="emailRadio">Email</label>
              </div>
            </div>
            <div class="col">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="smsRadio" name="sms" value="SMS" [(ngModel)]="updateUserModal.mfaPreference"
                  class="custom-control-input">
                <label class="custom-control-label" for="smsRadio">SMS</label>
              </div>
            </div>
            <div class="col">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="bothRadio" name="both" value="BOTH" [(ngModel)]="updateUserModal.mfaPreference"
                  class="custom-control-input">
                <label class="custom-control-label" for="bothRadio">Both</label>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="updateUserModal && updateUserModal.mfaPreference && (updateUserModal.mfaPreference == 'BOTH' || updateUserModal.mfaPreference == 'SMS')" 
          class="text-secondary pt-3 mb-4 mfaMessageBlock">
          <div><small>{{mfaSmsChargesMessage}}</small></div>
          <div class="mt-2" *ngIf="(!loggedInUser.phoneNumberVerified) || (loggedInUser.phoneNumberVerified && updateUserModal.phone != currentPhoneNumber)"><small>{{mfaUpdateButtonClickMessage}}</small></div>
          <div class="font11 mt-2"><a href="{{mfaTncLink}}" target="_blank">Terms & Conditions / Privacy Policy.</a></div>
        </div>

        <div>
          <button type="submit" class="btn btn-primary border pull-right btn-80">Update
          </button>
          <button (click)="initUpdateUserModal(); isShowUpdateUserForm = !isShowUpdateUserForm"
            class="btn btn-light border pull-right mr-2 btn-80">Cancel</button>
        </div>
      </form>
    </div>

  </div>
</div>
